'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const TitleEditor = styled.div`
  flex: 1;
  input {
    width: 100%;
    font-size: 24px;
    margin: 0;
    padding: 0;
    font-weight: 500;
    line-height: 110%;
    border: none;
    outline: none;
  }

  .edit-icon {
    cursor: pointer;

    &:hover {
      stroke-width: 2;
      filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.1));
    }
  }
`;

export const DescriptionEditor = styled.div`
  textarea {
    border: 1px solid ${colors.secondary.lightGray3};
    border-radius: 5px;
    outline: none;
  }

  .edit-icon {
    cursor: pointer;

    &:hover {
      stroke-width: 2;
      filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.1));
    }
  }
`;
